import React from 'react'

const SvgInboxOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 10.988a1 1 0 011 1 3 3 0 006 0 1 1 0 011-1h3.688L17.938 4H6.062l-1.749 6.988H8zm-4 2h3.1a5.002 5.002 0 009.8 0H20v7.001L4 20v-7.011zm18-1v8.001a2 2 0 01-1.999 2l-16 .01a2 2 0 01-2.001-2v-8.011l2.12-8.474A2 2 0 016.062 2H17.94a2 2 0 011.94 1.514L22 11.988z'
    />
  </svg>
)

export default SvgInboxOutline
